import { StyleProps, styled } from "../styles"
import { CrossCircledIcon, InfoCircledIcon } from "../Icons"

const ICON_SIZE = 20

type IconProps = {
  variant?: `error` | `info`
}

type Props = StyleProps & IconProps

const getBorderColor = (props: Props) => {
  if (props.variant === `error`) return props.theme.palette.error
  if (props.variant === `info`) return props.theme.palette.brand
  return undefined
}

const IconVariant = ({ variant }: IconProps) => {
  if (variant === `error`) return <CrossCircledIcon width={ICON_SIZE} height={ICON_SIZE} />
  if (variant === `info`) return <InfoCircledIcon width={ICON_SIZE} height={ICON_SIZE} />
  return null
}

IconVariant.defaultProps = {
  variant: undefined,
}

const StyledIcon = styled(IconVariant)((props: Props) => ({
  color: props.theme.palette.coal.dark,
  borderColor: getBorderColor(props),
}))

const Icon = ({ variant }: IconProps) => <StyledIcon variant={variant} />

Icon.defaultProps = {
  variant: undefined,
}

export default Icon
